import { useQuery } from "@tanstack/react-query";
import { tenantMeilisearchSearchKeyKeys } from "src/api/query-keys/tenant-meilisearch-search-key.keys";
import { generateTenantMeilisearchKey } from "src/api/lib/generate-tenant-meilisearch-key";
import useStore from "./use-store";

export const useGenerateTenantSearchKey = (enabled = true) => {
  const { user } = useStore();

  return useQuery({
    queryFn: generateTenantMeilisearchKey,
    queryKey: tenantMeilisearchSearchKeyKeys.detail(user?.userOrganizationId ?? ""),
    enabled,
  });
};
